<div class="layout-topbar">
  <a class="layout-topbar-logo" routerLink="home">
    <img
      src="assets/images/layout/{{
        layoutService.config.colorScheme === 'light'
          ? 'logo-dark'
          : 'logo-white'
      }}.svg"
      alt="DIALOG"
    />
  </a>
  <div class="po-logo">
    <img
      *ngIf="poLogo"
      class="w-full bg-auto bg-center"
      [src]="poLogo"
      alt="DIALOG"
    />
  </div>

  <!-- <app-base-dropdown-tree
    (onChange)="changeTenant($event)"
    [options]="tenantOptions"
    [fieldControl]="tenant"
  >
  </app-base-dropdown-tree> -->

  <button
    #menubutton
    class="p-link layout-menu-button layout-topbar-button"
    (click)="layoutService.onMenuToggle()"
  >
    <i class="pi pi-bars"></i>
  </button>

  <button
    #topbarmenubutton
    class="p-link layout-topbar-menu-button layout-topbar-button"
    (click)="layoutService.showProfileSidebar()"
  >
    <i class="pi pi-ellipsis-v"></i>
  </button>

  <div
    #topbarmenu
    class="layout-topbar-menu gap-3"
    [ngClass]="{
      'layout-topbar-menu-mobile-active':
        layoutService.state.profileSidebarVisible
    }"
  >
    <!-- <app-header-theme ngClass="icon"></app-header-theme> -->
    <app-header-language ngClass=""></app-header-language>
    <app-header-notification></app-header-notification>
    <app-header-avatar></app-header-avatar>
  </div>
</div>
